import { PublicClientApplication } from "@azure/msal-browser";

const tenant = process.env.NEXT_PUBLIC_AZURE_TENANT_ID;

export const b2cPolicies = {
  names: {
    signIn: "B2C_1_signin",
    passwordReset: "B2C_1_passwordreset",
  },
  authorities: {
    signIn: {
      authority: `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/B2C_1_signin`,
    },
    passwordReset: {
      authority: `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/B2C_1_Password_Reset`,
    },
  },
  knownAuthorities: [`${tenant}.b2clogin.com`],
};

export const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID,
    authority: b2cPolicies.authorities.signIn.authority,
    knownAuthorities: b2cPolicies.knownAuthorities,
    redirectUri: process.env.NEXT_PUBLIC_APP_URL,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
